import React from "react";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import Bank from "./Bank";
import Withdraw from "./Withdraw";
import HistoryWithdraw from "./HistoryWithdraw";
import Vip from "./Vip";
import HistoryDesposit from "./HistoryDesposit";
import Group from "./Group";
import Message from "./Message";
import UuDaiTaiChinh from "./page/UuDaiTaiChinh";
import UuDaiPhucLoi from "./page/UuDaiPhucLoi";
import MucTieu from "./page/MucTieu";
import SanPham from "./page/SanPham";
import ThayDoiMatKhau from "./page/ThayDoiMatKhau";
import HoSoLoiNhuan from "./page/HoSoLoiNhuan";
import MucDichGuiTietKiem from "./page/MucDichGuiTietKiem";
import LichSuGiaoDich from "./page/LichSuGiaoDich";
import Recharge from "./page/Recharge";
import ThongTinUngDung from "./page/ThongTinUngDung";
import CapDoCuaToi from "./pagenew/CapDoCuaToi";
import GioiThieuSanPham from "./pagenew/GioiThieuSanPham";
import LichSuNapTien from "./pagenew/LichSuNapTien";
import ThongBaoTinTuc from "./pagenew/ThongBaoTinTuc";
import TrungTamAnToan from "./pagenew/TrungTamAnToan";
import MatKhauDangNhap from "./pagenew/MatKhauDangNhap";
import MatKhauRutTien from "./pagenew/MatKhauRutTien";
import QuyTacGiamGia from "./pagenew/QuyTacGiamGia";
import SoDu from "./pagenew/SoDu";
import RutTien from "./pagenew/RutTien";
import ThemTaiKhoanNganHang from "./pagenew/ThemTaiKhoanNganHang";
import GhiChepDauTu from "./pagenew/GhiChepDauTu";
import BangBaoCao from "./pagenew/BangBaoCao";
import XuHuong from "./pagenew/XuHuong";
import ThamVan from "./pagenew/ThamVan";
import CSKH from "./pagenew/CSKH";
import CaiDatNgonNgu from "./pagenew/CaiDatNgonNgu";

const Home = React.lazy(() => import("./Home"));
const History = React.lazy(() => import("./History"));
const Account = React.lazy(() => import("./Account"));
const Cskh = React.lazy(() => import("./Cskh"));
const ChangePassword = React.lazy(() => import("./ChangePassword"));
const Notification = React.lazy(() => import("./Notification"));

export const webLayout: RouteObject[] = [
  { path: "", element: <Home /> },
  { path: "/account", element: <Account /> },
  { path: "/cap-do-cua-toi", element: <CapDoCuaToi /> },
  { path: "/gioi-thieu-san-pham", element: <GioiThieuSanPham /> },
  { path: "/lich-su-nap-tien", element: <LichSuNapTien /> },
  { path: "/thong-bao-tin-tuc", element: <ThongBaoTinTuc /> },
  { path: "/trung-tam-an-toan", element: <TrungTamAnToan /> },
  { path: "/mat-khau-dang-nhap", element: <MatKhauDangNhap /> },
  { path: "/mat-khau-rut-tien", element: <MatKhauRutTien /> },
  { path: "/quy-tac-giam-gia", element: <QuyTacGiamGia /> },
  { path: "/so-du", element: <SoDu /> },
  { path: "/rut-tien", element: <RutTien /> },
  { path: "/them-tai-khoan-ngan-hang", element: <ThemTaiKhoanNganHang /> },
  { path: "/ghi-chep-dau-tu", element: <GhiChepDauTu /> },
  { path: "/bang-bao-cao", element: <BangBaoCao /> },
  { path: "/xu-huong", element: <XuHuong /> },
  { path: "/tham-van", element: <ThamVan /> },
  { path: "/cskh", element: <Message /> },
  { path: "/cai-dat-ngon-ngu", element: <CaiDatNgonNgu /> },

  { path: "/history-order", element: <History /> },
  { path: "/bank", element: <Bank /> },
  { path: "/withdraw", element: <Withdraw /> },
  { path: "/history-withdraw", element: <HistoryWithdraw /> },
  { path: "/vip", element: <Vip /> },
  { path: "/change-password", element: <ChangePassword /> },
  { path: "/notification", element: <Notification /> },
  { path: "/history-desposit", element: <HistoryDesposit /> },
  { path: "/group", element: <Group /> },
  { path: "/message", element: <Message /> },

  { path: "/uu-dai-tai-chinh", element: <UuDaiTaiChinh /> },
  { path: "/uu-dai-phuc-loi", element: <UuDaiPhucLoi /> },
  { path: "/muc-tieu", element: <MucTieu /> },
  { path: "/san-pham", element: <SanPham /> },
  { path: "/thay-doi-mat-khau", element: <ThayDoiMatKhau /> },
  { path: "/ho-so-loi-nhuan", element: <HoSoLoiNhuan /> },
  { path: "/muc-dich-gui-tiet-kiem", element: <MucDichGuiTietKiem /> },
  { path: "/lich-su-giao-dich", element: <LichSuGiaoDich /> },
  { path: "/recharge", element: <Recharge /> },
  { path: "/lien-ket-ngan-hang", element: <Bank /> },
  // { path: "/withdraw-add", element: <RutTien /> },
  { path: "/thong-tin-ung-dung", element: <ThongTinUngDung /> },
];

const WebRoutes = () => useRoutes(webLayout);
export default WebRoutes;
